import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatAmount } from "../../../OperationsJournal/mock/operationsJournalMock";
import Drawer from "../../../shared/recognition/ui/Drawer";
import { formatPercent } from "../../utils/allocationBase";
import { JOURNAL_PATH } from "../../constants";
import "./RecordDrawer.css";

const Section = ({ title, children }) => (
  <section className="al-rd__section">
    <h3 className="al-rd__title">{title}</h3>
    {children}
  </section>
);

/** Карточка записи реестра: параметры запуска, доли проектов и сформированные операции */
function RecordDrawer({ record, onClose }) {
  const navigate = useNavigate();
  const [showEntries, setShowEntries] = useState(false);

  useEffect(() => {
    setShowEntries(false);
  }, [record?.id]);

  const params = record
    ? [
        { label: "Дата запуска", value: record.launchedAt },
        { label: "Пользователь", value: record.author },
        { label: "Период", value: record.period },
        { label: "База", value: record.baseShort, title: record.baseLabel },
        { label: "Проекты-получатели", value: record.recipientsCount },
        { label: "Общая сумма", value: formatAmount(record.total) },
      ]
    : [];

  return (
    <Drawer isOpen={Boolean(record)} onClose={onClose} title={record?.document}>
      {record && (
        <div className="al-rd">
          <Section title="Параметры запуска">
            <dl className="al-rd__list">
              {params.map((item) => (
                <div key={item.label} className="al-rd__row">
                  <dt>{item.label}</dt>
                  <dd title={item.title}>{item.value}</dd>
                </div>
              ))}
            </dl>
          </Section>

          <Section title="Распределение">
            <div className="al-rd__list">
              {record.rows.map((row) => (
                <div key={row.project.id} className="al-rd__share">
                  <span className="al-rd__project" title={row.project.name}>
                    {row.project.name}
                  </span>
                  <span className="al-rd__percent">{formatPercent(row.share)}</span>
                  <span className="al-rd__amount">{formatAmount(row.amount)}</span>
                </div>
              ))}
            </div>
          </Section>

          <Section title="Сформированные операции">
            <div className="al-rd__list">
              <div className="al-rd__row">
                <dt>Создано операций</dt>
                <dd className="al-rd__count">{record.entries.length}</dd>
              </div>
            </div>

            <div className="al-rd__links">
              <button
                type="button"
                className="al-rd__link"
                onClick={() =>
                  navigate(`${JOURNAL_PATH}?search=${encodeURIComponent(record.document)}`)
                }
              >
                Открыть в Журнале операций
              </button>
              <button
                type="button"
                className="al-rd__toggle"
                aria-expanded={showEntries}
                onClick={() => setShowEntries((value) => !value)}
              >
                {showEntries ? "Скрыть операции" : "Показать операции"}
              </button>
            </div>

            {showEntries && (
              <ul className="al-rd__entries">
                {record.entries.map((entry) => (
                  <li key={entry.id} className="al-rd__entry">
                    <div className="al-rd__entry-main">
                      <span className="al-rd__entry-doc">{entry.document}</span>
                      <span className="al-rd__entry-amount">{formatAmount(entry.amount)}</span>
                    </div>
                    <div className="al-rd__entry-meta">
                      {entry.sourceDocument} от {entry.sourceDate} → {entry.project.code} ·{" "}
                      {formatPercent(entry.share)}
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </Section>
        </div>
      )}
    </Drawer>
  );
}

export default RecordDrawer;
